<template>
    <v-container fluid fill-height class="main-container container-fixed d-block">
        <HeaderMenu v-model="hotel" :search="searchRoom" :edit="setEdit"></HeaderMenu>
        <div class="scroll-dashboard" v-if="(roomsDashboard && roomsDashboard.length > 0) || edit">
            <div class="common-text">
                <v-slide-group
                    mobile-breakpoint="lg"
                    mandatory
                    class="rooms-group"
                    v-for="(floor, indexFloor) in roomsDashboard"
                    :key="`floor-${indexFloor}`"
                    show-arrows
                >
                    <v-slide-item>
                        <div class="rooms-group__floor">
                            <span>{{floor.floor}} этаж</span>
                        </div>
                    </v-slide-item>
                    <v-slide-item
                        v-for="room in floor.rooms"
                        :key="room.uid"
                        class="mr-4"
                    >
                        <RoomComponent :data="room" :edit="edit" @editRoom="openEditRoom(room)">
                            <template v-slot:roomName>
                                № {{room.name}}
                            </template>
                        </RoomComponent>
                    </v-slide-item>
                    <v-slide-item class="mr-4" v-if="edit">
                        <v-btn class="btn-light-grey add-room" @click="addRoom(floor.floor)">
                            <PlusIcon></PlusIcon>
                            <div class="mt-3">Добавить номер</div>
                        </v-btn>
                    </v-slide-item>
                    <template #prev>
                        <v-img class="rorate90" max-width="28px" max-height="28px" :src="require('@/assets/icons/arrow_down_icon.svg')" />
                    </template>
                    <template #next>
                        <v-img class="rorate-90" max-width="28px" max-height="28px" :src="require('@/assets/icons/arrow_down_icon.svg')" />
                    </template>
                </v-slide-group>
            </div>
            <v-flex class="px-10 mt-8" xs12 v-if="edit">
                <v-btn class="btn-light-grey main-text" @click="addFloor">
                    Добавить этаж +
                </v-btn>
            </v-flex>
        </div>
        <div class="scroll-dashboard d-flex align-center" v-else>
            <v-flex class="d-block text-center">
                <div>
                    <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                    <div class="common-text text-center">
                        {{search ? "Увы, такой номер не найден" : "Нет добавленных номеров"}}
                    </div>
                </div>
            </v-flex>
        </div>
        <ModalWaiting ref="modalWaitingHotels" title="Загрузка списка отелей" no-cancel></ModalWaiting>
        <ModalAddRoom
            ref="modalAddRoom"
            :floor="floor"
            :hotel="hotel"
            :room="editRoom"
            @close="closeModalAddRoom"
        ></ModalAddRoom>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/HeaderMenu";
import RoomComponent from "@/components/rooms/RoomComponent";
import ModalWaiting from "@/components/modals/ModalWaiting";
import PlusIcon from "@/assets/icons/PlusIcon";
import ModalAddRoom from "@/components/modals/ModalAddRoom";
import { eventBus } from '@/main.js';

export default {
    name: 'HotelPage',
    components: { HeaderMenu, RoomComponent, ModalWaiting, PlusIcon, ModalAddRoom },
    data() {
        return {
            truth: false,
            rooms: [1, 2, 3],
            hotel: "",
            roomsDashboard: [],
            edit: false,
            floor: null,
            editRoom: null,
            search: null,
        }
    },
    created() {
        this.$root.$on('printPage', () => {
            window.print();
        });
        this.loadPage();
        eventBus.$on("reconnect", this.loadPage);
        eventBus.$on("room", this.setChange);
    },
    destroy() {
        this.$root.$on('printPage', () => {
            window.print();
        });
        eventBus.$off("reconnect", this.loadPage);
    },
    watch: {
        hotel(val) {
            if (val) {
                this.getHotelDashboard();
            }
        },
    },
    methods: {
        loadPage() {
            if (this.$route.query.hotel) {
                this.hotel = this.$route.query.hotel;
            }
        },
        getHotelDashboard(search = null) {
            this.roomsDashboard = [];
            this.$refs.modalWaitingHotels.open();
            let url = '/';
            if (search) {
                url = '/?name=' + search;
            }
            this.$http.get('/hotels/hotel-admin/hotels/rooms-dashboard/' + this.hotel + url)
                .then((response) => {
                    this.roomsDashboard = response.data.floors;
                    if (this.roomsDashboard.length == 0) {
                        this.edit = false;
                    }
                    this.$refs.modalWaitingHotels.close();
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.modalWaitingHotels.close();
                });
        },
        searchRoom(data) {
            this.search = data;
            this.getHotelDashboard(data);
        },
        setEdit(value) {
            this.edit = value;
        },
        addFloor() {
            if (this.roomsDashboard && this.roomsDashboard.length) {
                let last_floor = this.roomsDashboard[this.roomsDashboard.length - 1];
                this.roomsDashboard.push({floor: last_floor.floor + 1});
            } else {
                this.roomsDashboard.push({floor: 1, rooms: []});
            }
        },
        addRoom(floor) {
            this.floor = floor;
            this.$refs.modalAddRoom.open();
        },
        openEditRoom(room) {
            this.editRoom = room;
            this.$refs.modalAddRoom.open();
        },
        closeModalAddRoom() {
            this.editRoom = null;
            this.$refs.modalAddRoom.close();
        },
        setChange(data) {
            if (!data.is_delete) {
                this.editRoom = data.room;
                for (let i = 0; i < this.roomsDashboard.length; i++) {
                    let floor = this.roomsDashboard[i];
                    if (data.room.floor == floor.floor) {
                        let find = false;
                        for (let j = 0; j < floor.rooms.length; j++) {
                            if (data.room.uid == floor.rooms[j].uid) {
                                find = true;
                                floor.rooms[j] = data.room;
                            }
                        }
                        if (!find) {
                            floor.rooms.push(data.room);
                        }
                    }
                }
                this.editRoom = null;
            } else {
                this.editRoom = data.room;
                let floor = this.roomsDashboard.find(floor => {
                    return floor.floor == data.room.floor
                });
                if (floor) {
                    let index = floor.rooms.map(room => {
                        return room.uid
                    }).indexOf(data.room.uid);
                    floor.rooms.splice(index, 1);
                }
                this.editRoom = null;
            }
        },
    },
}
</script>

<style lang="scss">
.rorate90 {
    transform: rotate(90deg);
}

.rorate-90 {
    transform: rotate(-90deg);
}
</style>
